export const DownloadCSV = (columns, rows, fileName = "Report") => {
  if (!rows || rows.length === 0) {
    console.warn("No data available to download.");
    return;
  }

  // Extract headers
  const headers = columns.map(col => `"${col.label}"`).join(",");

  // Format each row
  const csvRows = rows.map(row =>
    columns.map(col => {
      let value = row[col.id];

      // Render if custom render exists
      if (typeof col.render === "function") {
        const rendered = col.render(row);
        if (typeof rendered === "string") {
          value = rendered;
        } else if (rendered?.props?.children) {
          value = rendered.props.children;
        }
      }

      if (value === undefined || value === null) value = "";

      // Escape double quotes and commas
      value = String(value).replace(/"/g, '""');
      return `"${value}"`;
    }).join(",")
  );

  const csvContent = [headers, ...csvRows].join("\r\n");

  // Add UTF-8 BOM and explicit MIME type
  const BOM = "\uFEFF";
  const blob = new Blob([BOM + csvContent], {
    type: "text/csv;charset=utf-8;"
  });

  // Create download link
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.href = url;
  link.setAttribute("download", `${fileName}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
